@if (candidate()) {
  <div
    #defaultEvalDropdownTrigger="rtOverlayOrigin"
    [class.bordered]="hasBorder()"
    [class.disabled]="disabled()"
    [class.dropdownOpened]="evalDropdown.open"
    [class.hovered]="state.hover"
    rt-overlay-origin
  >
    @if (hasTriggerContent()) {
      <rt-group>
        <rt-button
          [pressed]="evalDropdown.open"
          (click)="openDropdown(evalDropdown)"
          variant="primary"
        >
          <rt-icon name="add" />
          <span> {{ 'app.interview.add_evaluation' | translate }}</span>
        </rt-button>
      </rt-group>
    }
  </div>
}

<ng-template
  #evalDropdown="rtConnectedOverlay"
  [positions]="hasQuickEvaluationDropdown ? quickDropdownPositions : $any(null)"
  [origin]="defaultEvalDropdownTrigger"
  (backdropClick)="evalDropdown.open = false; evalDropdownClose.emit()"
  rt-connected-overlay
  hasBackdrop
>
  @if (!hasQuickEvaluationDropdown) {
    <rt-add-evaluation-dropdown
      [allowedUsers]="allowedUsers()"
      [templates]="state.templates"
      [offers]="state.offers"
      [dropdownRef]="evalDropdown"
      [candidate]="candidate()"
      (submit)="onSubmit({ event: $event })"
      (close)="evalDropdownClose.emit()"
    />
  }
  @if (hasQuickEvaluationDropdown) {
    <rt-add-quick-evaluation-dropdown
      [candidate]="candidate()"
      [placement]="placement()"
      [hasAccessToAllJobOffers]="hasAccessToAllJobOffers()"
      [availablePlacements]="currentUserAvailablePlacements()"
      [dropdownRef]="evalDropdown"
      [isActionToolbar]="isActionToolbar()"
      [quickEvaluationTrigger]="quickEvaluationTrigger()"
      (optionsClick)="optionsClick.emit($event)"
      (closeDialog)="evalDropdownClose.emit()"
    />
  }
</ng-template>
